const URL={
        submit:'/mast/saleorgmng/saleOrg/add',
        edit:'/mast/saleorgmng/saleOrg/modify',
        remove:'/mast/saleorgmng/saleOrg/delete',
        query:'/mast/saleorgmng/saleOrg/find',
        loadtree:'/mast/saleorgmng/saleOrg/lookup'
}

/**
 * 
 * @param {提交销售组织} data 
 * @param {回调函数} cb 
 */
async function submitSaleOrgan(data,cb){
  debugger;
  if(data==undefined){
      return;
  }
  let resResult = await this.$post(URL.submit,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 编辑销售组织
 * @param {*} data 
 * @param {*} cb 
 */
async function editSaleOrgan(data,cb){
  if(data==undefined){
      return;
  }
  let resResult = await this.$post(URL.edit,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

async function removeSaleOrgan(data,cb){
  if(data==undefined){
      return;
  }  
  let resResult = await this.$get(URL.remove,{saleOrgId:data["saleOrgId"]});
  if(cb&&resResult){
    cb(resResult);
  }
}


async function querySaleOrgan(data,cb){
    if(!data){
        return;
    }
    let resResult = await this.$get(URL.query,data);
    if(cb&&resResult){
      cb(resResult);
    }
}

/**
 * 加载销售组织树
 * @param {回调函数} cb 
 */
async function loadSaleOrgTree(data,cb){
    if(!data){
        return;
    }
    let resResult = await this.$post(URL.loadtree,data);
    if(cb&&resResult){
      cb(resResult);
    }
}

export default {
    submitSaleOrgan,
    editSaleOrgan,
    removeSaleOrgan,
    querySaleOrgan,
    loadSaleOrgTree
}